import { render, staticRenderFns } from "./DecorationServiceDetail.vue?vue&type=template&id=0b79bfb8&scoped=true"
import script from "./DecorationServiceDetail.vue?vue&type=script&lang=js"
export * from "./DecorationServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./DecorationServiceDetail.vue?vue&type=style&index=0&id=0b79bfb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b79bfb8",
  null
  
)

export default component.exports